import Modal from '@src/components/modal';
import React, { useCallback, useRef } from 'react';
import { noop } from '@src/utils/common-util.js';
import useUnmount from '@src/utils/hooks/use-unmount';

const useModal = (Component, settings) => {
  const ref = useRef(noop);
  const { onRequestClose, ...componentSettings } = settings || {};
  const open = useCallback(
    ({ extraProps } = {}) => {
      ref.current();
      ref.current = Modal.append(props => {
        const handleClose = onRequestClose ? () => onRequestClose(props.onClose) : props.onClose;

        return (
          <Modal centerContent visible={props.visible} onClose={handleClose} afterClose={props.afterClose}>
            <Component onClose={props.onClose} {...componentSettings} {...extraProps} />
          </Modal>
        );
      }).close;
      return ref.current;
    },
    [settings]
  );
  useUnmount(() => {
    ref.current();
  });
  const close = useCallback(ref.current, []);
  return { open, close };
};

export default useModal;
